module.exports = __webpack_public_path__ + "static/media/family-recipes.436a65a2.png";